// extracted by mini-css-extract-plugin
export default {"section":"views-ContentPage-components-themes-BGH-latestProducts__section--G27lZ"};